export default "__VITE_ASSET__V_1sNHgQ__"